import getAmplitudeDeviceId from '../scripts/amplitudeDeviceId';

const PAYPAL_AMPLITUDE_DEVICE_ID_QUERY_PARAM = 'paypal_amplitude_device_id';
const DEVICE_ID_WAIT_TIMEOUT_MS = 2000;
const DEVICE_ID_WAIT_INTERVAL_MS = 50;

function getExpectedAmplitudeDeviceId(url?: string): string {
  try {
    const targetUrl = new URL(url || window.location.href);
    return (
      targetUrl.searchParams.get(PAYPAL_AMPLITUDE_DEVICE_ID_QUERY_PARAM) || ''
    );
  } catch {
    return '';
  }
}

export function attachPaypalAmplitudeDeviceId(
  redirectUrl: URL,
  amplitudeDeviceId: string
): URL {
  if (amplitudeDeviceId) {
    redirectUrl.searchParams.set(
      PAYPAL_AMPLITUDE_DEVICE_ID_QUERY_PARAM,
      amplitudeDeviceId
    );
  }

  return redirectUrl;
}

export async function resolveShouldSkipAmplitudeForPaypalRedirect(
  url?: string
): Promise<boolean> {
  const expectedDeviceId = getExpectedAmplitudeDeviceId(url);
  if (!expectedDeviceId) {
    return false;
  }

  const startedAt = Date.now();
  let currentDeviceId = getAmplitudeDeviceId();

  while (
    !currentDeviceId &&
    Date.now() - startedAt < DEVICE_ID_WAIT_TIMEOUT_MS
  ) {
    await new Promise(resolve =>
      window.setTimeout(resolve, DEVICE_ID_WAIT_INTERVAL_MS)
    );
    currentDeviceId = getAmplitudeDeviceId();
  }

  if (!currentDeviceId) {
    return true;
  }

  return expectedDeviceId !== currentDeviceId;
}

export { PAYPAL_AMPLITUDE_DEVICE_ID_QUERY_PARAM };
